import { useAuth } from '@/composables/useAuth'

export default defineNuxtRouteMiddleware(() => {
	const { cookie } = useAuth()
	if (!cookie.value) {
		return navigateTo('/register', {
			replace: true
		})
	}
})
